<template lang="pug">
  #billing.container-fluid
    h1 Billing
    .card.shadow.mb-4
      .card-body
        form.vcc-credit-card-preview(@submit="submitPaying")
          .vcc-credit-card-front.vcc-credit-card
            .vcc-credit-card-inner
              .vcc-credit-card-number.vcc-text-shadow
                //- | **** **** **** 4242
                CardNumber.stripe-element.card-number(
                  ref="cardNumber"
                  :stripe="stripeInstance"
                  :options="stripeOptions.number"
                  @change="handleCardNumberChange"
                )
              .vcc-credit-card-holder.vcc-text-shadow
                //- | Yeh Tso-En
                input.stripe-element.card-holder(placeholder="Card Holder" ref="cardHolder")
              .vcc-credit-card-expiry.vcc-text-shadow  
                CardExpiry#card-expiry.stripe-element.card-expiry(
                  ref="cardExpiry"
                  :stripe="stripeInstance"
                  @change="handleCardExpiryChange"
                )
              //- .vcc-credit-card-expiry-month.vcc-text-shadow
                //- <input type="text" placeholder="Expiry Month -->
                | 10
              //- .vcc-credit-card-expiry-year.vcc-text-shadow
                //- <input type="text" placeholder="Expiry Year -->
                | 25
              .vcc-credit-card-type
                //- img.vcc-credit-card-type-image(src="https://github.com/fracto-team/vue-credit-card/blob/master/src/assets/visa_icon.png?raw=true")
                img.vcc-credit-card-type-image(v-if="cardInfo.brand && cardInfo.brand !== 'unknown'" :src="img(cardInfo.brand)")
                .unknown-card(v-if="!cardInfo.brand || cardInfo.brand === 'unknown'")
                //- span.vcc-card-type-text VISA
          .vcc-credit-card-back.vcc-credit-card
            .vcc-credit-card-inner
              .vcc-credit-card-magnet &nbsp;
              .vcc-credit-card-cvv
                //- <input type="text" placeholder="CVV"> -->
                CardCvc#card-cvc.stripe-element.card-cvc(
                  ref="cardCvc"
                  :stripe="stripeInstance"
                  @change="handleCardCVCChange"
                )
          button.btn.btn-primary(@click="submitPaying") Save

        p.stripe-error(v-if="stripeError")
          | {{stripeError}}

        
        ul.warning-text
          li We do not store your billing information on our servers.
          li Your billing information is saved securely by our payment processor.
          //- h3 
          //- h3 Your billing information is saved securely by our payment processor.


    
</template>

<script>
/* global Stripe */
import Vue from 'vue';
import { CardNumber, CardExpiry, CardCvc, createToken } from 'vue-stripe-elements-plus'
import { mapActions, mapState } from 'vuex';
import axios from 'axios';

export default {
  name: 'Billing',
  components: {
    CardNumber,
    CardExpiry,
    CardCvc,
  },
  data() {
    return{
      cardDetail: {
        number: '',
        name: '',
        expiry: '',
        cvc: ''
      },
      cardInfo: {
        number: {
          complete: false,
          error: ''
        },
        expiry: {
          complete: false,
          error: ''
        },
        cvc: {
          complete: false,
          error: ''
        },
        brand: '',
        // visa, mastercard, amex, discover, diners, jcb, unionpay, unknown
      },
      stripeError: null,
      stripeOptions: {
        number: {
          // classes: { base:'zzzzzzz' },
          // placeholder: this.last4 ? `**** **** **** ${this.last4}` : '', 
          // placeholder: '**** **** **** 4242', 
          placeholder: '', 
        },
        expiry: {
          locale: 'en',
        },
        cvc: {},
      }
    }
  },
  computed: {
      ...mapState(['last4']),
      stripeInstance() {
        return Stripe('pk_test_dsU09CCLSW3D1nx0GWOTQXY300XGS8WDLb', { locale: 'en' })
      },
      img() {
        return (name) => require(`@/assets/img/creditcards/${name}_icon.png`);
      }
  },
  methods: {
    ...mapActions(['updateUser']),
    handleCardNumberChange(e) {
      let { cardInfo, brand } = this;
      
      // stripeError = e.error ? e.error.message : '';
      // console.log('---- e', e);
      // console.log('---- error1 ?', stripeError);
      this.stripeError = e.error ? e.error.message : '';
      // console.log('---- error2 ?', stripeError);

      
      cardInfo.number.error = '';
      cardInfo.number.complete = e.complete;
      cardInfo.brand = e.brand;
    },
    handleCardExpiryChange(e) {
      let { stripeError, cardInfo } = this;
      stripeError = e.error ? e.error.message : '';
      cardInfo.expiry.error = '';
      cardInfo.expiry.complete = e.complete
    },
    handleCardCVCChange(e) {
      let { stripeError, cardInfo } = this;
      stripeError = e.error ? e.error.message : '';
      cardInfo.cvc.error = '';
      cardInfo.cvc.complete = e.complete
    },
    clearElementsInputs() {
      this.cardCvc.clear()
      this.cardExpiry.clear()
      this.cardNumber.clear()
    },
    clearCardErrors() {
      this.stripeError = ''
      this.cardCvcError = ''
      this.cardExpiryError = ''
      this.cardNumberError = ''
    },

    validate () {
      const { cardDetail, $cardFormat } = this;
      let { cardErrors } = this;
      cardErrors = {};
      
      // console.log('--- validate');
      // if(!$cardFormat.validateCardNumber(cardDetail.number)){
      //   console.log('--- Invalid Credit Card Number')
      //   cardErrors.number = "Invalid Credit Card Number.";
      //   return false;
      // }

      // if (!$cardFormat.validateCardExpiry(cardDetail.expiry)) {
      //   console.log('--- Invalid Expiration Date')
      //   cardErrors.expiry = "Invalid Expiration Date.";
      //   return false;
      // }

      // if (!$cardFormat.validateCardCVC(cardDetail.cvc)) {
      //   console.log('--- Invalid CVC')
      //   cardErrors.cvc = "Invalid CVC.";
      //   return false;
      // }

      // console.log('--- validated yes');
      return true;
    },
    async submitPaying (e) {
      e.preventDefault();
      const result = await createToken();
      // console.log(result)

      const { 
        token: {
          id: stripeToken
        } = {}
      } = result;

      let formData = new FormData();
      formData.append('stripeToken', stripeToken);
      let billingResponse;
      
      if(this.last4) {
        try {
          billingResponse = await axios.post('/rp/server/billing/update/', formData);
        } catch (error) {
          this.flash(`Ops, Something went wrong, ${error}`, 'error');
        }
      } else {
        try {
          billingResponse = await axios.post('/rp/server/billing/add/', formData);
          await this.updateUser({ 'last4': billingResponse.data.billing.last4 });
        } catch (error) {
          this.flash(`Ops, Something went wrong, ${error}`, 'error');
        }
      }

      if (billingResponse.error) {
        this.flash(billingResponse.error, 'error');
      } else {
        this.flash('Success', 'success');
      }
    },
  },
  watch: {
    'cardInfo.number.complete': {
      handler(val) {
        if (val) { this.$refs.cardHolder.focus(); }
      }
    },
    'cardInfo.expiry.complete': {
      handler(val) {
        if (val) { this.$refs.cardCvc.focus(); }
      }
    },
  },
  created() {
    this.stripeOptions.number.placeholder = this.last4 ? `**** **** **** ${this.last4}` : 'Card Number';
  },
  mounted() { 
    setTimeout(() => {
      this.$refs.cardNumber && this.$refs.cardNumber.focus();  
    }, 2000);
    // console.log('--- mounted');
    // this.$refs.cardNumber.focus();
  },
  metaInfo: {
    title: 'Billing',
  }
 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#billing {
  label {
    display: block;
  }
  .card-wrap {
    width: 500px;
    margin-top: 40px;
    margin-left:40px;
    padding: 25px 0;
  }
  
  .creditcard-form {
    width: 350px; 
    display: flex;
    flex-direction: column;
    align-items: left;
    margin: 25px auto auto 75px;

    input {
      margin-top: 5px;
    }
    .form-group {
      display: flex;
    }
    .card-number {
      width: 220px;
    }
    .full-name {
      width: 150px;
    }
    .expiry {
      width: 110px;
    }
    .cvc {
      width: 80px;
    }
  }


  // input {
  //   width: 100%;
  // }
  .vcc-credit-card-preview {
    position: relative;
    background-color: #fff;
    font-family: "Ubuntu", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 230px;
    margin-bottom: 12px;
    background-color: transparent;


    .stripe-element {
      width: 100%;
      background-color: transparent;
      font-size: 14px;
      line-height: 24px;
      font-family: Helvetica Neue;
    }
    .card-holder {
      border: 0px;
      padding: 0;
      border-radius: 0;
      height: 24px;
    }
    .card-holder::placeholder {
      color: #b2bcc7;
    }


    .vcc-credit-card {
      width: 240px;
      height: 150px;
      position: absolute;
      background-color: #dbdbdb;
      border: 1px solid #cdcdcd;
      border-radius: 12px;
    }
    .vcc-credit-card-front {
      z-index: 2;
      -webkit-box-shadow: 2px 2px 6px 0 rgba(0, 0, 0, 0.4);
      -moz-box-shadow: 2px 2px 6px 0 rgba(0, 0, 0, 0.4);
      box-shadow: 2px 2px 6px 0 rgba(0, 0, 0, 0.4);
    }
    .vcc-credit-card-back {
      z-index: 1;
      top: 30px;
      left: 78px;
      background-color: #cacaca;
    }
    .vcc-credit-card-inner {
      position: relative;
      width: 100%;
      height: 100%;
    }
    .vcc-credit-card-magnet {
      position: absolute;
      top: 30px;
      left: 0;
      width: 100%;
      height: 30px;
      background-color: #4a4a4a;
    }
    .vcc-credit-card-cvv {
      position: absolute;
      width: 42px;
      font-size: 14px;
      line-height: 14px;
      text-align: center;
      // height: 14px;
      padding: 4px;
      border: 1px solid #acacac;
      background-color: #fff;
      // top: 100px;
      // left: 170px;
      bottom: 15px;
      right: 15px;
    }
    .vcc-credit-card-holder {
      position: absolute;
      top: 100px;
      left: 14px;
      font-size: 14px;
      line-height: 14px;
      color: #2d2d2d;
      font-weight: bold;
      width: 210px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .vcc-credit-card-expiry {
      position: absolute;
      top: 120px;
      right: 15px;
      font-size: 14px;
      line-height: 14px;
      min-width: 62px
    }
    // .vcc-credit-card-expiry-month {
    //   position: absolute;
    //   top: 120px;
    //   right: 34px;
    //   font-size: 14px;
    //   line-height: 14px;
    // }
    // .vcc-credit-card-expiry-year {
    //   position: absolute;
    //   top: 120px;
    //   right: 20px;
    //   font-size: 14px;
    //   line-height: 14px;
    // }
    // .vcc-credit-card-expiry-month:after {
    //   content: "\00a0/\00a0\00a0";
    // }
    .vcc-credit-card-number {
      position: absolute;
      width: 200px;
      top: 60px;
      left: calc(50% - calc(200px / 2));
      font-size: 20px;
      height: 20px;
      font-weight: bold;
      text-align: left;
      line-height: 22px;
    }
    .vcc-text-shadow {
      color: #2d2d2d;
      font-weight: bold;
      text-shadow: 2px 2px #fff;
    }
    .vcc-credit-card-type {
      position: absolute;
      top: 10px;
      right: 20px;
      width: 60px;
      height: 38px;
      background-color: #4a4a4a;
      border-radius: 4px;
      text-align: center;
      color: #fff;
      font-size: 12px;
      line-height: 36px;
      text-transform: capitalize;

      .vcc-credit-card-type-image {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }
      .unknown-card {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        background-color: #4a4a4a;
      }

    }
    .btn {
      width: 200px;
      position: absolute;
      bottom: 0px;
    }
  }
}
  
</style>
